import { render, staticRenderFns } from "./TopContentNew.vue?vue&type=template&id=2bb0ebc2&"
import script from "./TopContentNew.vue?vue&type=script&lang=js&"
export * from "./TopContentNew.vue?vue&type=script&lang=js&"
import style0 from "./TopContentNew.vue?vue&type=style&index=0&id=2bb0ebc2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CardsCourseCardsOnline: require('/opt/build/repo/components/Cards/CourseCardsOnline.vue').default})
